import { IAsyncActionCallback } from '@state/types';
import { User, UserManager } from 'oidc-client';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';

export const signIn = (userManager: UserManager, user: User, dsPermissions: string[], callback: IAsyncActionCallback): actionsInterfaces.ISignInAction => {
  return {
    type: actionsTypes.SIGN_IN,
    userManager,
    user,
    dsPermissions,
    callback
  };  
};

export const publicSignIn = (userManager: UserManager, user: User | null, shareToken: string, callback: IAsyncActionCallback): actionsInterfaces.IPublicSignInAction => {
  return {
    type: actionsTypes.PUBLIC_SIGN_IN,
    userManager,
    user,
    shareToken,
    callback
  };  
};

export const createShareToken = (entityType: string, entityId: string, callback: IAsyncActionCallback): actionsInterfaces.ICreateShareTokenAction => {
  return {
    type: actionsTypes.CREATE_SHARE_TOKEN,
    entityType,
    entityId,
    callback
  };  
};

export const setAuth = (userManager?: UserManager, user?: User, token?: string): actionsInterfaces.ISetAuthAction => {
  return {
    type: actionsTypes.SET_AUTH,
    userManager,
    user,
    token
  };  
};

export const setShareToken = (shareToken: string): actionsInterfaces.ISetShareTokenAction => {
  return {
    type: actionsTypes.SET_SHARE_TOKEN,
    shareToken
  };  
};

export const serverError = (error: any): actionsInterfaces.IServerErrorAction => {
  return {
    type: actionsTypes.SERVER_ERROR,
    error
  }; 
};
